import { v4 as uuidv4 } from "uuid";

export class FocusPayDevice {
	key: string;
	type: string;
	venueKey: number;
	dealerKey: string;
	created: Date;
	updated: Date;
	ipAddress: string;
	uuid: string = uuidv4();
	deviceId: string;
	venueAssignment: string;
	newDevice: boolean;

	disabled: boolean;

	public constructor(init?: Partial<FocusPayDevice>) {
		Object.assign(this, init);
	}
}
